
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'; // Make sure to import Routes, not Route directly
import NavbarComponent from './components/NavbarComponent'



function App() {
  return (
    <div className="App">
    <NavbarComponent />
  </div>
  );
}

export default App;


